/** URL params that drive the UI only and must never reach the backend / retrigger a fetch. */
const CLIENT_ONLY_PARAMS = ["refresh"];

/**
 * The query string a list page sends to its endpoint. Stripping the client-only params
 * here means changing the auto-refresh interval doesn't count as a data change, so the
 * page's fetch effect stays put instead of firing an extra request.
 */
export const toQuery = (searchParams: URLSearchParams): string => {
  const params = new URLSearchParams(searchParams);
  CLIENT_ONLY_PARAMS.forEach((key) => params.delete(key));
  return params.toString();
};

/** Auto-refresh choices, in seconds. 0 = off. */
export const REFRESH_INTERVALS = [0, 5, 10, 15, 30, 60];

export const parseRefresh = (searchParams: URLSearchParams): number => {
  const raw = Number(searchParams.get("refresh"));
  return REFRESH_INTERVALS.includes(raw) ? raw : 0;
};
